import React from 'react'
import { styled } from '@mui/system'

const StyledHeading = styled('div')(() => ({
    fontSize: '1.5rem',
    fontWeight: '600',
    letterSpacing: '0em',
    textAlign: 'left',
    color: 'black'
}))

const Heading2 = ({ heading }) => (
    <StyledHeading>
        {heading}
    </StyledHeading>
)

export default Heading2
